import {
  Container,
  Form,
  Modal,
  Col,
  Row,
  Button,
  Image,
} from "react-bootstrap";
import { Select, TextField, FormControl, IconButton } from "@material-ui/core";
import React, { useState, useEffect, Fragment } from "react";
//import SuperAdminCreateOrders from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminCreateOrders";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import FormatColorFillOutlinedIcon from "@material-ui/icons/FormatColorFillOutlined";
import ColorPicker from "../../../reusableComponents/colorPicker/colorPicker";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Media from "react-media";

import {
  // prepareDataForValidation,
  useFormik,
} from "formik";
import PropTypes from "prop-types";
import * as yup from "yup";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import {
  CREATE_ORDER_VENDOR,
  FILTERED_MENU_ORDER,
} from "../../../../../src/store/types";
import { get_category_menu_setup } from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  create_or_check_user_order,
  get_takeAway_time,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import Alert from "react-s-alert";
import { ORDER_TYPE_NAME } from "../../../../enums/OrderEnums";

function RePaymentCustomerEditModel(props) {
  // console.log(props);
  // constructor(props) {
  //   super(props);
  //   state = {
  //     open: false,
  //     takeaway: 0,
  //     ordertype: 0,
  //     vehicletype: 0,
  //     deliverytype: 0,
  //     timeslot: 0,
  //     first_name:props.user_data &&
  //       props.user_data.user_details &&
  //       props.user_data.user_details.first_name,
  //     last_name:props.user_data &&
  //     props.user_data.user_details &&
  //     props.user_data.user_details.last_name,
  //     phone:props.user_data &&
  //           props.user_data.user_details &&
  //           props.user_data.user_details.mobile_number,
  //     timeSlots:[],
  //     timeDate:"",
  //   };
  // }

  // console.log(
  //   moment(1627331400000).format("ll"),

  //   moment(1627331400000).format("LT")
  // );

  let history = useHistory();

  const locationState = useLocation();
  const [showSkipTheLine, setShowSkipTheLine] = useState(true);
  const [showTakeAway, setShowTakeAway] = useState(true);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const [open, setOpen] = useState(false);
  const data = locationState?.state?.data || null;
  const [background, setBackground] = useState({
    color: data?.background || "#EE3A23",
    picker: false,
  });
  const onChangeHandler = (type) => (color) => {
    if (type === "BACKGROUND")
      setBackground({ color: color, picker: !background.picker });
    formik.setFieldValue("curb_side_details.color", color);
  };

  const [showLaterTakeAway, setShowLaterTakeAway] = useState(false);

  const [showLaterCurbSide, setShowLaterCurbSide] = useState(false);

  const dispatch = useDispatch();
  const validate = (values) => {
    const errors = {};
    const regex = RegExp(/^[A-Z]{2}\s[0-9]{2}\s[A-Z]{2}\s[0-9]{4}$/i);

    if (values.order_type === 1) {
      if (!values.curb_side_details.number) {
        errors.number = "Please enter vehicle number";
      } else if (!regex.test(values.curb_side_details.number)) {
        errors.number = "Invalid vehicle number";
      }
      if (!values.curb_side_details.make) {
        errors.make = "Please enter make";
      }
      if (!values.curb_side_details.model) {
        errors.model = "Please enter model";
      }
      if (!values.curb_side_details.year) {
        errors.year = "Please enter year";
      }
      if (!values.curb_side_details.color) {
        errors.color = "Please enter color";
      }
    }

    if (values.order_type === 3) {
      if (!values.dine_in_details?.table_number) {
        errors.table_number = "Please enter table number";
      }
    }

    // if (values.food_type.length === 0) {
    //   errors.food_type = "Please select food type";
    // }

    return errors;
  };
  const [state, setState] = useState({
    takeaway: 0,
    ordertype: 0,
    vehical_type: 4,
    deliverytype: 0,
    vehical_type_value: "4-wheeler",
  });
  const { takeaway, ordertype, vehical_type, deliverytype } = state;
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onChangeTakeAwayNow = () => {
    setState({ ...state, takeaway: 0 });
    formik.setFieldValue("now", true);
    formik.setFieldValue("later_date", "");
  };

  const onChangeTakeAwayLater = () => {
    setState({ ...state, takeaway: 1 });
    formik.setFieldValue("now", false);
    formik.setFieldValue("later_date", minDate);
  };

  const onClickChangeVechileType = (data) => {
    setState({
      ...state,
      vehical_type: data.id,
      vehical_type_value: data.title,
    });
    formik.setFieldValue("curb_side_details.vehical_type", data.id);
    formik.setFieldValue("curb_side_details.vehical_type_value", data.title);
  };

  const onChangeOrderType = (id) => {
    setState({ ...state, ordertype: id });
    formik.setFieldValue("order_type", id);
    // setTimeSlots([]);
  };

  const onClickNext = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };
  const orderTypes = [
    {
      id: 0,
      title: "Takeaway",
      show: true,
      image: require("../../../../assets/images/Orders/takeaway.svg"),
    },
    {
      id: 1,
      title: "Curb-side",
      show: showCurbSide,
      image: require("../../../../assets/images/Orders/curb side.svg"),
    },
    {
      id: 2,
      title: "Skip-The Line",
      show: showSkipTheLine,
      image: require("../../../../assets/images/Orders/skip the line .svg"),
    },
    {
      id: 3,
      title: "Dine-In",
      show: showDineIn,
      image: require("../../../../assets/images/Orders/dine in.svg"),
    },
    {
      id: 4,
      title: "Buffet",
      show: false,
      image: require("../../../../assets/images/Orders/Buffet.svg"),
    },
    {
      id: 5,
      title: "Delivery",
      show: false,
      image: require("../../../../assets/images/Orders/Home delivery new icon.svg"),
    },
    {
      id: 6,
      title: "Drive Thru",
      show: false,
      image: require("../../../../assets/images/Orders/Drive thru.svg"),
    },
    {
      id: 7,
      title: "Catering",
      show: false,
      image: require("../../../../assets/images/Orders/catering.svg"),
    },
  ];

  const [timeSlots, setTimeSlots] = useState([]);

  const prepareData = (data, selectedDate) => {
    let tempData = [];
    for (let i = 0; i < data.length; i++) {
      tempData.push({
        id: i,
        title: data[i],
        value: (data[i].slice(0, -2) + ":00").replace(/\s/g, ""),
      });
    }
    setTimeSlots(tempData);
    formik.setFieldValue("later_date", selectedDate);
    formik.setFieldValue("later_formDated_date", "");
    setDateTime("");
  };

  const [timeDate, setDateTime] = useState("");
  const onSuccessGetTime = (data, selectedDate) => {
    let CurrentDate = new Date();
    let selectedDateFormat = new Date(selectedDate);
    if (selectedDateFormat > CurrentDate) {
      prepareData(data, selectedDate);
    } else {
      let min = moment().format("hh:mm A");
      let max = "11:59 PM";
      let result = [];
      if (min.slice(-2) === "PM") {
        let filteredPM = data.filter((word) => word.includes("PM"));
        for (let i = 0; i < filteredPM.length; i++) {
          if (filteredPM[i][1] === ":") {
            filteredPM[i] = "0" + filteredPM[i];
          }
        }
        result = filteredPM.filter((a) => a > min && a < max);
        prepareData(result, selectedDate);
      } else {
        max = "11:59 AM";
        let filteredPM = data.filter((word) => word.includes("PM"));
        let filteredAM = data.filter((word) => word.includes("AM"));
        for (let i = 0; i < filteredAM.length; i++) {
          if (filteredAM[i].startsWith("0")) {
            filteredAM[i] = "0" + filteredAM[i];
          }
        }
        result = filteredAM.filter((a) => a > min && a < max);
        result = [...result, ...filteredPM];
        prepareData(result, selectedDate);
      }
    }
  };

  const vendorAccessId = useSelector((state) =>
    state.vendorAccess ? state.vendorAccess?.vendor_id : null
  );

  const onChangeDate = (date) => {
    const token = props.auth.user.accessToken;
    const vendorId = vendorAccessId
      ? vendorAccessId
      : props.auth.user.VendorUser._id;
    props.get_takeAway_time(
      token,
      vendorId,
      formik.values.order_type === 0
        ? "TAKEAWAY"
        : formik.values.order_type === 1
        ? "CURBSIDE"
        : "",
      date,
      onSuccessGetTime,
      (err) => onError(err)
    );
  };

  const onSetDateTime = (id, timeValue) => {
    let formDate = new Date(
      `${moment(formik.values.later_date).format("YYYY-MM-DD")} ${timeValue}`
    ).getTime();
    formik.setFieldValue("later_formDated_date", formDate);
    setDateTime(id);
  };

  const onError = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const formik = useFormik({
    initialValues: {
      user_details: {
        first_name: "",
        last_name: "",
        country_code: "",
        mobile_number: "",
      },
      order_type: 0,
      now: true,
      nowDate: new Date(),
      later_date: "",
      later_formDated_date: "",
      curb_side_details: {
        vehical_type: "",
        vehical_type_value: "",
        number: "",
        make: "",
        model: "",
        year: "",
        color: "#EE3A23",
      },
      dine_in_details: {
        table_number: "",
      },
    },
    validationSchema: yup.object({
      user_details: yup.object({
        first_name: yup
          .string()
          .required("First name is required")
          .min(1, "Minimum 1 Character")
          .max(64, "Maximum 64 Character"),

        mobile_number: yup
          .string()
          .required("Phone number is required")
          .min(10, "Phone number must be of 10 characters")
          .max(10, "Phone number must be of 10 characters"),
      }),
    }),
    validate,
    //enableReinitialize: true,
    onSubmit: (values) => {
      if (values.order_type === 0 && timeDate === "" && !values.now) {
        Alert.error(`<h4>Please select time</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else if (values.order_type === 1 && timeDate === "" && !values.now) {
        Alert.error(`<h4>Please select time</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        let orderSelected = "";
        if (values.order_type === 0) {
          orderSelected = "take_away";
        } else if (values.order_type === 1) {
          orderSelected = "curb_side";
        } else if (values.order_type === 2) {
          orderSelected = "skip_line";
        } else if (values.order_type === 3) {
          orderSelected = "dine_in";
        } else if (values.order_type === 7) {
          orderSelected = "home_delivery";
        }

        let filteredMenuData = [];

        for (let i = 0; i < props.menuCategory.length; i++) {
          let tempCategory = JSON.parse(JSON.stringify(props.menuCategory[i]));
          tempCategory.items = [];

          //tempCategory.items.filteredItems = [];

          for (let j = 0; j < props.menuCategory[i].items.length; j++) {
            if (
              props.menuCategory[i].items[j][orderSelected].value &&
              props.menuCategory[i].items[j].status
            ) {
              let dataToSend = JSON.parse(
                JSON.stringify(props.menuCategory[i].items[j])
              );

              dataToSend[orderSelected].sizes = [];
              dataToSend.cartLength = 0;

              for (
                let m = 0;
                m < props.menuCategory[i].items[j][orderSelected].sizes.length;
                m++
              ) {
                if (
                  props.menuCategory[i].items[j][orderSelected].sizes[m]
                    .available
                ) {
                  dataToSend[orderSelected].sizes.push(
                    props.menuCategory[i].items[j][orderSelected].sizes[m]
                  );
                }
              }

              tempCategory.items.push(dataToSend);
            }
          }
          if (tempCategory.items.length > 0) {
            filteredMenuData.push(tempCategory);
          }
          tempCategory = {};
        }

        values.orderSelected = orderSelected;
        if (
          values.order_type === 0 ||
          (values.order_type === 1 && !values.now)
        ) {
          values.later_date = values.later_formDated_date;
        } else if (values.order_type === 0 && values.now) {
          values.later_date = new Date().getTime();
        }
      }
    },
  });

  const [minDate, setMinDate] = useState("");
  const [maxDateTakeAway, setMaxDateTakeAway] = useState("");
  const [maxDateCurbSide, setMaxDateCurbSide] = useState("");
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    onChangeDate(data);
    setMinDate(data);
    if (
      props.servicesEnabled &&
      props.servicesEnabled.cubside_delivery &&
      props.servicesEnabled.cubside_delivery.order_for_future
    ) {
      let myDate = new Date(
        new Date().getTime() +
          props.servicesEnabled.cubside_delivery.max_date * 24 * 60 * 60 * 1000
      );
      let formatDate = moment(myDate).format("YYYY-MM-DD");
      setMaxDateTakeAway(formatDate);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.take_away &&
      props.servicesEnabled.take_away.order_for_future
    ) {
      let myDate = new Date(
        new Date().getTime() +
          props.servicesEnabled.take_away.max_date * 24 * 60 * 60 * 1000
      );
      let formatDate = moment(myDate).format("YYYY-MM-DD");
      setMaxDateCurbSide(formatDate);
    }
  }, [props.servicesEnabled]);

  useEffect(() => {
    if (props.orderData.user_details) {
      formik.setValues(props.orderData);
      setState({
        ...state,
        ordertype: formik?.values?.order_type,
        vehical_type: formik?.values?.curb_side_details?.vehical_type,
      });
    }
  }, [props.orderData]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    if (formik?.values?.order_type === 0) {
      props.get_takeAway_time(
        token,
        vendorId,
        "TAKEAWAY",
        moment().format("YYYY-MM-DD"),
        onSuccessGetTime,
        (err) => onError(err)
      );
    } else {
      props.get_takeAway_time(
        token,
        vendorId,
        "CURBSIDE",
        moment().format("YYYY-MM-DD"),
        onSuccessGetTime,
        (err) => onError(err)
      );
    }
  }, [formik?.values?.order_type]);

  // useEffect(() => {
  //   if (props.auth.user.VendorUser.country_code) {
  //     formik.setFieldValue(
  //       "user_details.country_code",
  //       props.auth.user.VendorUser.country_code
  //     );
  //   }
  //   const token = props.auth.user.accessToken;
  //   props.get_category_menu_setup(token);
  // }, []);

  useEffect(() => {
    if (
      props.servicesEnabled &&
      props.servicesEnabled.cubside_delivery &&
      props.servicesEnabled.cubside_delivery.value &&
      props.sessionSettings &&
      props.sessionSettings.curb_side
    ) {
      setShowCurbSide(true);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.cubside_delivery &&
      props.servicesEnabled.cubside_delivery.order_for_future &&
      props.futureOrders &&
      props.futureOrders.curb_side
    ) {
      setShowLaterCurbSide(true);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.dine_in_order &&
      props.servicesEnabled.dine_in_order.value &&
      props.sessionSettings &&
      props.sessionSettings.dine_in_order
    ) {
      setShowDineIn(true);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.take_away &&
      props.servicesEnabled.take_away.value &&
      props.sessionSettings &&
      props.sessionSettings.take_away
    ) {
      setShowTakeAway(true);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.take_away &&
      props.servicesEnabled.take_away.order_for_future &&
      props.futureOrders &&
      props.futureOrders.take_away
    ) {
      setShowLaterTakeAway(true);
    }
  }, [props.servicesEnabled, props.sessionSettings, props.futureOrders]);

  const onCloseModal = () => {
    setOpen(false);
  };

  const calcPrepTIme = () => {
    let bufferTime = props.orderBufferTime;
    let all_time_arr = [];

    for (let i = 0; i < props.cart_data.length; i++) {
      if (
        props.cart_data[i][0] &&
        props.cart_data[i][0].item &&
        props.cart_data[i][0].item.prepTime
      )
        all_time_arr.push(props.cart_data[i][0].item.prepTime);
    }
    let max_time = 0;
    max_time = Math.max(...all_time_arr);
    if (bufferTime !== "" && bufferTime) {
      max_time = max_time + parseInt(bufferTime.split("-")[1]);
    }
    return max_time;
  };

  const changeHandler = (e) => {
    // console.log(e.target.value);
    setState({
      [e.target.name]: e.target.value,
    });
  };

  // console.log(props.user_data);
  // const { open, takeaway, ordertype, vehicletype, deliverytype, timeslot,first_name,phone,last_name,changeHandler } =
  //   state;
  return (
    <div>
      <Modal show={open} size="lg" onHide={onCloseModal} centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Edit Order Details
          </Modal.Title>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <Container
            fluid
            className="superadmin-orderscomponent-main"
            style={{ padding: 0 }}
          >
            <Form
              className="col-12 pb-5"
              // style={{ padding: "1%" }}
            >
              <Form.Group>
                <Row>
                  <Col md={6} sm={12}>
                    <TextField
                      id="first_name"
                      label="First Name"
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.user_details &&
                        formik.errors.user_details.first_name &&
                        formik.touched.user_details &&
                        formik.touched.user_details.first_name
                          ? "enError"
                          : ""
                      }`}
                      name="user_details.first_name"
                      onChange={formik.handleChange}
                      value={
                        formik.values.user_details &&
                        formik.values.user_details.first_name
                      }
                      onBlur={formik.handleBlur}
                      //onInvalid={formik.errors.email && formik.touched.email}
                    />
                    {formik.errors.user_details &&
                    formik.errors.user_details.first_name &&
                    formik.touched.user_details &&
                    formik.touched.user_details.first_name ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.user_details.first_name}
                      </div>
                    ) : null}
                  </Col>
                  <Col md={6} sm={12}>
                    <TextField
                      id="last_name"
                      label="Last Name"
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.user_details &&
                        formik.errors.user_details.last_name &&
                        formik.touched.user_details &&
                        formik.touched.user_details.last_name
                          ? "enError"
                          : ""
                      }`}
                      name="user_details.last_name"
                      onChange={formik.handleChange}
                      value={
                        formik.values.user_details &&
                        formik.values.user_details.last_name
                      }
                      onBlur={formik.handleBlur}
                      //onInvalid={formik.errors.email && formik.touched.email}
                    />
                    {/* {formik.errors.user_details &&
                          formik.errors.user_details.last_name &&
                          formik.touched.user_details &&
                          formik.touched.user_details.first_name ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.user_details.last_name}
                            </div>
                          ) : null} */}
                    <br />
                    <br />
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col xs={4} className="pr-0">
                        <Form.Group
                          // className="reusableInputComponent-main mb-0"
                          controlId={"country_code"}
                        >
                          <div className="input-phone-country-code-reusable w-100">
                            <select
                              id="user_details.country_code"
                              name="user_details.country_code"
                              value={formik.values?.user_details?.country_code}
                              onChange={formik.handleChange}
                              className="w-100"
                            >
                              <option
                                value={
                                  formik.values?.user_details?.country_code
                                }
                              >
                                {formik.values?.user_details?.country_code}
                              </option>
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              ))}
                            </select>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={8}>
                        <Form.Group>
                          <NewInputText
                            controlClass={"mobile_number"}
                            //id="outlined-basic"
                            placeHolder="Mobile Number"
                            type="number"
                            labelText="Phone Number"
                            variant="outlined"
                            extraClass={`w-100 mb-1 ${
                              formik.errors.user_details &&
                              formik.errors.user_details.mobile_number &&
                              formik.touched.user_details &&
                              formik.touched.user_details.mobile_number
                                ? "enError"
                                : ""
                            }`}
                            onInput={maxLengthCheck}
                            maxLength={10}
                            //onKeyDown={InputNumberFunc}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            name="user_details.mobile_number"
                            onChange={formik.handleChange}
                            value={
                              formik.values.user_details &&
                              formik.values.user_details.mobile_number
                            }
                            onFocusOut={formik.handleBlur}
                            //onInvalid={formik.errors.email && formik.touched.email}
                          />
                          {formik.errors.user_details &&
                          formik.errors.user_details.mobile_number &&
                          formik.touched.user_details &&
                          formik.touched.user_details.mobile_number ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.user_details.mobile_number}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <br />
                    <br />
                  </Col>
                </Row>
                <Row>
                  {/* <Col sm={12}>
                        <div className="col-12 p-0">
                          <h3 className="f20-700 mb-2">Order Type</h3>
                          <h4 className="f14-500 mb-4">
                            Select one relevant option from below
                          </h4>
                        </div>
                        <Media query="(min-width: 991px)">
                        <Row style={{ width: "50%" }}
                          {orderTypes.map((data, index) => {
                            return (
                              <Fragment key={index}>
                                {data.show ? (
                                  <>
                                    <div
                                      className="col-3 mb-5 text-center"
                                      onClick={() =>
                                        onChangeOrderType(data.id)
                                      }
                                      key={data.id}
                                    >
                                      <div>
                                        <div
                                          className={`d-flex align-items-center justify-content-center take-away-order-select
                                        ${
                                          ordertype === data.id &&
                                          `take-away-order-select-selected`
                                        }`}
                                          style={{
                                            borderRadius: "50px",
                                            width: "55px",
                                            height: "55px",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <Image
                                            src={data.image}
                                            // width="22px"
                                            // height="25px"
                                            className="rounded-circle img-fluid"
                                          />
                                        </div>
                                        <div className="mt-3 f10-700">
                                          {data.title}
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <Fragment></Fragment>
                                )}
                              </Fragment>
                            );
                          })}
                        </Row>
                        </Media>
                        <Media query="(max-width: 991px)">
                        <Row>
                          {orderTypes.map((data, index) => {
                            return (
                              <Fragment key={index}>
                                {data.show ? (
                                  <>
                                    <div
                                      className="col-3 mb-5 text-center"
                                      onClick={() =>
                                        onChangeOrderType(data.id)
                                      }
                                      key={data.id}
                                    >
                                      <div>
                                        <div
                                          className={`d-flex align-items-center justify-content-center take-away-order-select
                                        ${
                                          ordertype === data.id &&
                                          `take-away-order-select-selected`
                                        }`}
                                          style={{
                                            borderRadius: "50px",
                                            width: "55px",
                                            height: "55px",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <Image
                                            src={data.image}
                                            // width="22px"
                                            // height="25px"
                                            className="rounded-circle img-fluid"
                                          />
                                        </div>
                                        <div className="mt-3 f10-700">
                                          {data.title}
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <Fragment></Fragment>
                                )}
                              </Fragment>
                            );
                          })}
                        </Row>
                        </Media>
                      </Col> */}

                  <Col sm={12}>
                    {/* {ordertype === 0 && ( */}
                    {props?.user_data?.order_type === 0 && (
                      <>
                        <h5 className="f16-500 mb-4">
                          Please select the option for your take away order
                        </h5>
                        <div>
                          <Button
                            className={`btn btn-md py-3 f14-500 bg-white mr-4 shadow-sm ${
                              props?.user_data?.now
                                ? `take-away-order-select-selected`
                                : `border-0`
                            }`}
                            style={{ color: "#000" }}
                            onClick={() => {
                              onChangeTakeAwayNow();
                            }}
                          >
                            Now
                          </Button>
                          {showLaterTakeAway ? (
                            <Button
                              className={`btn btn-md py-3 f14-500 bg-white shadow-sm ${
                                props?.user_data?.now
                                  ? `border-0`
                                  : `take-away-order-select-selected`
                              }`}
                              style={{
                                color: "#000",
                              }}
                              onClick={() => {
                                onChangeTakeAwayLater();
                              }}
                            >
                              Later
                            </Button>
                          ) : (
                            <> </>
                          )}
                        </div>
                        <br />
                        <br />
                      </>
                    )}
                    {/* )} */}
                    {/* <Row> */}
                    <Col xs={12} className="p-0">
                      {/* {takeaway === 1 && ordertype === 0 && ( */}
                      {props?.user_data?.order_type === 0 &&
                      props?.user_data?.now === false ? (
                        <Fragment>
                          <Row>
                            <Col md={4} xs={12}>
                              <div className="f16-500 mb-3">Select Date</div>
                              <TextField
                                defaultValue={minDate}
                                label="Select Date"
                                variant="outlined"
                                type="date"
                                values={formik.values.later_date}
                                //onChange={formik.handleChange}
                                onChange={(e) => onChangeDate(e.target.value)}
                                className="w-100"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: minDate,
                                    max: maxDateTakeAway,
                                  },
                                }}
                                name="date"
                              />
                            </Col>
                          </Row>
                          {timeSlots && timeSlots.length > 0 && (
                            <div className="mt-4 mb-4">
                              <div className="f14-500 mb-2">Select Time</div>
                              <div className="f10-400 mb-2 opacity5">
                                The displayed time slots depend upon the
                                availability of the restaurant.
                              </div>
                            </div>
                          )}
                          <Row
                            style={{
                              marginTop: "10px",
                            }}
                          >
                            {timeSlots.map((data) => {
                              // console.log(data);
                              return (
                                <Col
                                  xs={6}
                                  sm={3}
                                  md={2}
                                  className="mb-3"
                                  onClick={() => {
                                    onSetDateTime(data.id, data.value);
                                  }}
                                  key={data.id}
                                >
                                  <Button
                                    className={`btn btn-md f14-500 bg-white mr-4 shadow-sm w-100 py-3 px-2 ${
                                      // timeDate === data.id
                                      moment(
                                        props?.user_data?.later_date
                                      ).format("LT") === data.title
                                        ? `take-away-order-select-selected`
                                        : `border-0`
                                    }`}
                                    style={{ color: "#000" }}
                                  >
                                    {data.title}
                                  </Button>
                                </Col>
                              );
                            })}
                          </Row>
                        </Fragment>
                      ) : (
                        <></>
                      )}
                      {/* )} */}
                    </Col>
                    {/* </Row> */}
                    {/* {ordertype === 1 && ( */}
                    {props?.user_data?.order_type === 1 && (
                      <>
                        {/* {ordertype === 1 && ( */}
                        <>
                          <h4 className="f16-500 mb-4">
                            Please select the option for your Curb Side order
                          </h4>
                          <div>
                            <Button
                              className={`btn btn-md py-3 f14-500 bg-white mr-4 shadow-sm ${
                                props?.user_data?.now
                                  ? `take-away-order-select-selected`
                                  : `border-0`
                              }`}
                              style={{ color: "#000" }}
                              onClick={() => {
                                onChangeTakeAwayNow();
                              }}
                            >
                              Now
                            </Button>
                            {showLaterTakeAway ? (
                              <Button
                                className={`btn btn-md py-3 f14-500 bg-white shadow-sm ${
                                  props?.user_data?.now
                                    ? `border-0`
                                    : `take-away-order-select-selected`
                                }`}
                                style={{
                                  color: "#000",
                                }}
                                onClick={() => {
                                  onChangeTakeAwayLater();
                                }}
                              >
                                Later
                              </Button>
                            ) : (
                              <> </>
                            )}
                          </div>
                          <br />
                          <br />
                        </>

                        {/* )} */}
                        <Row>
                          <Col xs={12}>
                            {/* {takeaway === 1 && ordertype === 1 && ( */}
                            {props?.user_data?.order_type === 1 &&
                            props?.user_data?.now === false ? (
                              <Fragment>
                                <Row>
                                  <Col md={4} xs={12}>
                                    <div className="f16-500 mb-3">
                                      Select Date
                                    </div>
                                    <TextField
                                      defaultValue={minDate}
                                      label="Select Date"
                                      variant="outlined"
                                      type="date"
                                      values={formik.values.later_date}
                                      //onChange={formik.handleChange}
                                      onChange={(e) =>
                                        onChangeDate(e.target.value)
                                      }
                                      className="w-100"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: minDate,
                                          max: maxDateCurbSide,
                                        },
                                      }}
                                      name="date"
                                    />
                                  </Col>
                                </Row>
                                {timeSlots && timeSlots.length > 0 && (
                                  <div className="mt-4 mb-4">
                                    <div className="f14-500 mb-2">
                                      Select Time
                                    </div>
                                    <div className="f10-400 mb-2 opacity5">
                                      The displayed time slots depend upon the
                                      availability of the restaurant Time
                                    </div>
                                  </div>
                                )}
                                <Row
                                  style={{
                                    // marginLeft: "2%",
                                    marginTop: "10px",
                                  }}
                                >
                                  {timeSlots.map((data) => {
                                    return (
                                      <Col
                                        xs={6}
                                        sm={3}
                                        md={2}
                                        className="mb-3"
                                        onClick={() => {
                                          onSetDateTime(data.id, data.value);
                                        }}
                                        key={data.id}
                                      >
                                        <Button
                                          className={`btn btn-md f14-500 bg-white mr-4 shadow-sm w-100 py-3 px-2 ${
                                            // timeDate === data.id
                                            moment(
                                              props?.user_data?.later_date
                                            ).format("LT") === data.title
                                              ? `take-away-order-select-selected`
                                              : `border-0`
                                          }`}
                                          style={{ color: "#000" }}
                                        >
                                          {data.title}
                                        </Button>
                                      </Col>
                                    );
                                  })}
                                </Row>
                              </Fragment>
                            ) : (
                              <></>
                            )}
                            {/* )} */}
                          </Col>
                          <Col xs={12}>
                            <h5 className="f18-700 mt-4">
                              Vehicle Information
                            </h5>
                            <p
                              className="f10-400 w-75 mt-2"
                              style={{ color: "#606060" }}
                            >
                              Please enter your vehicle number to get your order
                              delivered near by your vehicle.
                            </p>
                            <p
                              className="f10-400 w-75 mt-1"
                              style={{ color: "#606060" }}
                            >
                              Do ensure that you are in or near by your vehicle.
                            </p>
                          </Col>
                          <Col xs={8} className="my-4">
                            <div className="container-fluid">
                              <Row>
                                {vechileTypes.map((data) => {
                                  return (
                                    <Col
                                      md={2}
                                      className="pl-0"
                                      key={data.id}
                                      xs={6}
                                    >
                                      <div
                                        className={`rounded-icons text-center m-auto
                                                ${
                                                  vehical_type === data.id &&
                                                  `rounded-icons-selected`
                                                }`}
                                        // onClick={() => {
                                        //   setState({
                                        //     ...state,
                                        //     vehical_type: data.id,
                                        //   });
                                        // }}
                                        onClick={() =>
                                          onClickChangeVechileType(data)
                                        }
                                      >
                                        <img
                                          className="rounded-circle"
                                          src={data.icon}
                                          alt={data.title}
                                          width="100%"
                                        />
                                      </div>
                                      <h5 className="f10-700 mt-2">
                                        {data.title}
                                      </h5>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </div>
                          </Col>
                          <Col md={6} xs={8}>
                            <TextField
                              label="Vehicle Number"
                              variant="outlined"
                              type="text"
                              className={`w-100 ${
                                formik.errors.number &&
                                formik.touched.curb_side_details &&
                                formik.touched.curb_side_details.number
                                  ? "enError"
                                  : ""
                              }`}
                              inputProps={{ maxLength: 13 }}
                              name="curb_side_details.number"
                              value={formik.values.curb_side_details.number}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.number &&
                            formik.touched &&
                            formik.touched.curb_side_details &&
                            formik.touched.curb_side_details.number ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.number}
                              </div>
                            ) : null}
                            <br />
                            <br />
                          </Col>
                          <Col xs={12}>
                            <Row>
                              <Col md={3} xs={6}>
                                <TextField
                                  label="Make"
                                  variant="outlined"
                                  className={`w-100 ${
                                    formik.errors.make &&
                                    formik.touched.curb_side_details &&
                                    formik.touched.curb_side_details.make
                                      ? "enError"
                                      : ""
                                  }`}
                                  name="curb_side_details.make"
                                  value={formik.values.curb_side_details.make}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />

                                {formik.errors.make &&
                                formik.touched &&
                                formik.touched.curb_side_details &&
                                formik.touched.curb_side_details.make ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.make}
                                  </div>
                                ) : null}
                                <br />
                              </Col>
                              <Col md={3} xs={6}>
                                <TextField
                                  label="Model"
                                  variant="outlined"
                                  className={`w-100 ${
                                    formik.errors.model &&
                                    formik.touched.curb_side_details &&
                                    formik.touched.curb_side_details.model
                                      ? "enError"
                                      : ""
                                  }`}
                                  name="curb_side_details.model"
                                  value={formik.values.curb_side_details.model}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />

                                {formik.errors.model &&
                                formik.touched &&
                                formik.touched.curb_side_details &&
                                formik.touched.curb_side_details.model ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.model}
                                  </div>
                                ) : null}
                                <br />
                              </Col>
                              <Col md={2} xs={5}>
                                <TextField
                                  label="Year"
                                  variant="outlined"
                                  className={`w-100 ${
                                    formik.errors.year &&
                                    formik.touched.curb_side_details &&
                                    formik.touched.curb_side_details.year
                                      ? "enError"
                                      : ""
                                  }`}
                                  name="curb_side_details.year"
                                  value={formik.values.curb_side_details.year}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />

                                {formik.errors.year &&
                                formik.touched &&
                                formik.touched.curb_side_details &&
                                formik.touched.curb_side_details.year ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.year}
                                  </div>
                                ) : null}
                                <br />
                              </Col>
                              <Col md={2} xs={5}>
                                <TextField
                                  id="curb_side_details.color"
                                  label="Color"
                                  variant="outlined"
                                  className={`w-100 ${
                                    formik.errors.color &&
                                    formik.touched.curb_side_details &&
                                    formik.touched.curb_side_details.color
                                      ? "enError"
                                      : ""
                                  }`}
                                  disabled={true}
                                  type="text"
                                  name="curb_side_details.color"
                                  value={formik.values.curb_side_details.color}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.errors.color &&
                                formik.touched &&
                                formik.touched.curb_side_details &&
                                formik.touched.curb_side_details.color ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.color}
                                  </div>
                                ) : null}
                                <br />
                              </Col>
                              <Col md={2} xs={2}>
                                <div
                                  style={{
                                    display: "inline-block",
                                    marginLeft: "10px",
                                    boxShadow: "0px 0px 10px gray",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <IconButton
                                    size="medium"
                                    onClick={() =>
                                      setBackground({
                                        ...background,
                                        picker: !background.picker,
                                      })
                                    }
                                  >
                                    <FormatColorFillOutlinedIcon
                                      style={{
                                        color: background.color,
                                      }}
                                    />
                                  </IconButton>
                                </div>
                                {background.picker && (
                                  <ColorPicker
                                    onColorChange={onChangeHandler(
                                      "BACKGROUND"
                                    )}
                                  />
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </>
                      //  )}
                    )}
                    {/* {ordertype === 3 || ordertype === 2 ? ( */}
                    {/* {console.log(props?.user_data?.prder_type)} */}
                    {props?.user_data?.order_type === 2 ? (
                      <div className="container-fluid px-0">
                        <h5 className="f16-700 mb-2">Table Information</h5>
                        <p className="f11-400" style={{ color: "#606060" }}>
                          Please enter your table number to get your order
                          delivered at your table.
                        </p>
                        <br />
                        <Row>
                          <Col md={6} xs={12}>
                            <TextField
                              label="Table Number/Seat Number"
                              variant="outlined"
                              className={`w-100 ${
                                formik.errors.table_number &&
                                formik.touched.dine_in_details &&
                                formik.touched.dine_in_details.table_number
                                  ? "enError"
                                  : ""
                              }`}
                              name="dine_in_details.table_number"
                              value={formik.values.dine_in_details.table_number}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />

                            {formik.errors.table_number &&
                            formik.touched &&
                            formik.touched.dine_in_details &&
                            formik.touched.dine_in_details.table_number ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.table_number}
                              </div>
                            ) : null}
                            <br />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {props?.user_data?.order_type === 3 ? (
                      <div className="container-fluid px-0">
                        <h5 className="f16-700 mb-2">Table Information</h5>
                        <p className="f11-400" style={{ color: "#606060" }}>
                          Please enter your table number to get your order
                          delivered at your table.
                        </p>
                        <br />
                        <Row>
                          <Col md={6} xs={12}>
                            <TextField
                              label="Table Number/Seat Number"
                              variant="outlined"
                              className={`w-100 ${
                                formik.errors.table_number &&
                                formik.touched.dine_in_details &&
                                formik.touched.dine_in_details.table_number
                                  ? "enError"
                                  : ""
                              }`}
                              name="dine_in_details.table_number"
                              value={formik.values.dine_in_details.table_number}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />

                            {formik.errors.table_number &&
                            formik.touched &&
                            formik.touched.dine_in_details &&
                            formik.touched.dine_in_details.table_number ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.table_number}
                              </div>
                            ) : null}
                            <br />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {ordertype === 7 && (
                      <div className="container-fluid">
                        <h5>Delivery Address</h5>
                        <br />
                        <p>
                          Please enter your address to get your order delivered.
                          Do ensure that you are in or near by address.
                        </p>
                        <br />
                        <Col xs={12}>
                          <div
                            className="container-fluid"
                            style={{ marginBottom: "1%" }}
                          >
                            <Row>
                              {deliveryTypes.map((data) => {
                                return (
                                  <Col md={3} key={data.id} xs={6}>
                                    <div
                                      className={`rounded-icons 
                                                ${
                                                  deliverytype === data.id &&
                                                  `rounded-icons-selected`
                                                }`}
                                      onClick={() => {
                                        setState({
                                          deliverytype: data.id,
                                        });
                                      }}
                                    >
                                      <img
                                        className="rounded-circle"
                                        src={data.icon}
                                        alt={data.title}
                                        width="100%"
                                      />
                                    </div>
                                    {data.title}
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        </Col>
                        <br />
                        <Row>
                          <Col md={6}>
                            <Row>
                              <Col xs={12}>
                                <TextField
                                  label="House Number"
                                  variant="outlined"
                                  className="w-100"
                                  name="housenumber"
                                />
                                <br />
                                <br />
                              </Col>
                              <Col md={6}>
                                <TextField
                                  label="Area"
                                  variant="outlined"
                                  className="w-100"
                                  name="area"
                                />
                                <br />
                                <br />
                              </Col>
                              <Col md={6}>
                                <TextField
                                  label="Locality"
                                  variant="outlined"
                                  className="w-100"
                                  name="locality"
                                />
                                <br />
                                <br />
                              </Col>
                              <Col md={6}>
                                <TextField
                                  label="City"
                                  variant="outlined"
                                  className="w-100"
                                  name="city"
                                />
                                <br />
                                <br />
                              </Col>
                              <Col md={6}>
                                <TextField
                                  label="PIN/ZIP Code"
                                  variant="outlined"
                                  className="w-100"
                                  name="pincode"
                                />
                                <br />
                                <br />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    )}
                    <div className="d-flex align-items-center pt-5">
                      <Button
                        variant="outline-secondary"
                        className="mr-4 px-5 py-2"
                        onClick={onCloseModal}
                      >
                        Cancel
                      </Button>
                      <Button variant="danger" className="px-5  py-2">
                        Save Changes
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
      {/* <div className="f16-700 d-flex justify-content-between">
        Customer Order Details
        <span
          onClick={() => {
            setOpen(true);
          }}
          style={{ color: "#EE3A23", cursor: "pointer" }}
        >
          Edit
        </span>
      </div> */}
      <div className="f14-500" style={{ paddingTop: "3%" }}>
        {/* Order Type -{" "} */}
        <span
          className="badge badge-warning mr-2 px-3 py-2 f9-500 text-uppercase"
          style={{ borderRadius: 50 }}
        >
          {/* {props.user_data && props.user_data.order_type === 0
            ? "Take Away"
            : props.user_data && props.user_data.order_type === 1
              ? "Curb Side"
              : props.user_data && props.user_data.order_type === 2
                ? "Skip the line"
                : props.user_data && props.user_data.order_type === 3
                  ? "Dine In"
                  : null} */}
          {ORDER_TYPE_NAME[props.user_data && props.user_data.order_type]}
        </span>
        &nbsp;
        {!props.payment && (
          <span
            onClick={() => {
              props.history.push("/addorder");
              //setState({ open: true });
            }}
            style={{ color: "#2196F3", cursor: "pointer" }}
            className="f12-500"
          >
            Change Order Type
          </span>
        )}
      </div>
      <hr />
      <div
        style={{ marginTop: "3%" }}
        className="icons-for-border-black mobile-d-flex"
      >
        <div className="icons-for-border-black f12-500 mobile-border-right mobile-f10-500 mobile-image-10px mobile-mr-3 mb-3">
          <img
            src={require("../../../../assets/images/superadmin/ordericon/1-03.svg")}
            width="20px"
            heigth="20px"
            alt="Profile Pic"
          />{" "}
          &nbsp;{" "}
          {props.user_data &&
            props.user_data.user_details &&
            props.user_data.user_details.first_name}{" "}
          {props.user_data &&
            props.user_data.user_details &&
            props.user_data.user_details.last_name}
        </div>
        <div className="icons-for-border-black f12-500 mobile-border-right  mobile-f10-500 mobile-image-10px mobile-mr-3 mb-3">
          <img
            src={require("../../../../assets/images/superadmin/ordericon/1-02.svg")}
            width="20px"
            heigth="20px"
            alt="Code"
          />{" "}
          &nbsp;{" "}
          {props.user_data &&
            props.user_data.user_details &&
            props.user_data.user_details.country_code}{" "}
          {props.user_data &&
            props.user_data.user_details &&
            props.user_data.user_details.mobile_number}
        </div>
        {props.cart_data?.length > 0 ? (
          <div className=" mobile-f10-500 mobile-image-10px">
            <img
              src={require("../../../../assets/images/superadmin/ordericon/1-01.svg")}
              width="20px"
              heigth="20px"
              alt="Time"
            />{" "}
            &nbsp;{" "}
            {/* {props.cart_data.length.length > 0 ? (
                <>{calcPrepTIme()} mins </>
              ) : (
                <></>
              )} */}
            {/* {calcPrepTIme()} */}
            {props?.user_data?.max_time} mins
            <br />
            &nbsp;{" "}
            <span
              style={{
                fontSize: ".85rem",
                marginLeft: "20px",
                color: "#757575",
              }}
            >
              Estimated PrepTime
            </span>
          </div>
        ) : (
          <> </>
        )}
      </div>
      {props.user_data && props.user_data.order_type === 0 ? (
        <div className="row">
          <hr />
          <div className=" col-6 col-md-12">
            <div className="f12-500">
              Requested Date :{" "}
              {/* {props?.user_data?.order_type === 0 ||
              props?.user_data?.now === true
                ? moment(props?.user_data.nowDate).format("Do MMMM YYYY")
                : moment(props?.user_data?.later_date).format("Do MMMM YYYY")} */}
              {moment(props?.user_data?.OrderAcceptTime).format("Do MMMM YYYY")}
            </div>
          </div>
          <div className=" col-6 col-md-12">
            <div className="f12-500">
              Requested Time :{" "}
              {/* {props?.user_data?.order_type === 0 ||
              props?.user_data?.now === true
                ? moment(props?.user_data.nowDate).format("hh : mm A")
                : moment(props?.user_data?.later_date).format("LT")} */}
              {moment(props?.user_data?.OrderAcceptTime).format("hh:mm A")}
            </div>
          </div>
        </div>
      ) : (
        <> </>
      )}
      {!props.top && (
        <>
          {props.user_data && props.user_data.order_type === 3 ? (
            <div className="f12-500">
              Table Number: {props.user_data.dine_in_details?.table_number}
            </div>
          ) : (
            <> </>
          )}

          {props.user_data && props.user_data.order_type === 1 ? (
            <Row>
              <Col sm={3}>
                <img
                  src={require("../../../../assets/images/superadmin/ordericon/car.svg")}
                  width="100%"
                  alt="Car"
                />{" "}
              </Col>

              <Col sm={7}>
                <b>
                  {props.user_data &&
                    props.user_data.curb_side_details &&
                    props.user_data.curb_side_details.number}
                </b>
                <p style={{ color: "#747474" }}>
                  {props.user_data &&
                    props.user_data.curb_side_details &&
                    props.user_data.curb_side_details.model}{" "}
                  {props.user_data &&
                    props.user_data.curb_side_details &&
                    props.user_data.curb_side_details.make}
                  |{" "}
                </p>
                {props?.user_data?.curb_side_details?.color !== "" ? (
                  <div
                    className="mt-1"
                    style={{
                      width: "15px",
                      height: "15px",
                      borderRadius: "50%",
                      backgroundColor: `${props?.user_data?.curb_side_details?.color}`,
                      boxShadow: "0px 4px 8px #00000029",
                    }}
                  ></div>
                ) : (
                  ""
                )}
              </Col>
              {/* <Col sm={2}>Edit</Col> */}
            </Row>
          ) : (
            <> </>
          )}
          <hr />
          {props.cart === 0 && (
            <div
              style={{
                fontSize: "1.5rem",
                color: "#000000",
                opacity: 0.4,
                marginTop: "8%",
              }}
            >
              Your cart is empty. Add an item to begin
            </div>
          )}
        </>
      )}
    </div>
  );
}

// const orderTypes = [
//   { id: 0, title: "Takeaway" },
//   { id: 1, title: "Curb-side" },
//   { id: 2, title: "Skip-The Line" },
//   { id: 3, title: "Dine-In" },
//   { id: 4, title: "Buffet" },
//   { id: 5, title: "Catering" },
//   { id: 6, title: "Drive Thru" },
//   { id: 7, title: "Delivery" },
// ];

// const timeSlots = [
//   { id: 0, title: "09:30 AM" },
//   { id: 1, title: "10:45 AM" },
//   { id: 2, title: "11:00 AM" },
//   { id: 3, title: "11:30 AM" },
//   { id: 4, title: "11:45 AM" },
//   { id: 5, title: "12:00 PM" },
// ];

const vechileTypes = [
  {
    id: 0,
    title: "4-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/car.svg"),
  },
  {
    id: 1,
    title: "2-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/scooter.svg"),
  },
  {
    id: 2,
    title: "3-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/rikshaw.svg"),
  },
  {
    id: 3,
    title: "Others",
    icon: require("../../../../assets/images/superadmin/ordericon/taxi.svg"),
  },
];

const deliveryTypes = [
  {
    id: 0,
    title: "Indepdent House",
    icon: require("../../../../assets/images/superadmin/ordericon/house.svg"),
  },
  {
    id: 1,
    title: "HighRise",
    icon: require("../../../../assets/images/superadmin/ordericon/HighRise.svg"),
  },
  {
    id: 2,
    title: "Community",
    icon: require("../../../../assets/images/superadmin/ordericon/Community.svg"),
  },
  {
    id: 3,
    title: "Gated",
    icon: require("../../../../assets/images/superadmin/ordericon/gated.svg"),
  },
];

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
//   user_data: state.vendorOrdering.vendor_order_data,
// });
RePaymentCustomerEditModel.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  create_or_check_user_order: PropTypes.func.isRequired,
  get_takeAway_time: PropTypes.func.isRequired,
  user_data: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allergy_info: state.category.allergy_info,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
  orderData: state.vendorOrdering.vendor_order_data,
  menuCategory: state.onboarding.menuCategory,
  //food_type: state.onboarding.restaurantDetails.selected_food_type,
  servicesEnabled:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining
      ? state.onboarding.onboard_subscription_details.fast_food_dining_status &&
        state.onboarding.onboard_subscription_details.fast_food_dining_status
          .ordering
      : state.onboarding.onboard_subscription_details.casual_dining_status &&
        state.onboarding.onboard_subscription_details.casual_dining_status
          .ordering,
  sessionSettings:
    state.onboarding &&
    state.onboarding.restaurantDetails &&
    state.onboarding.restaurantDetails.orderSessionSettings,
  futureOrders:
    state.onboarding &&
    state.onboarding.restaurantDetails &&
    state.onboarding.restaurantDetails.future_activities &&
    state.onboarding.restaurantDetails.future_activities.order,
  user_data: state.vendorOrdering.vendor_order_data,
  // &&
  //state.onboarding.restaurantDetails.sessionSettings,
});

// export default connect(mapStateToProps, {
//   get_category_menu_setup,
//   create_or_check_user_order,
//   get_takeAway_time,
// })(AddOrder);

export default connect(mapStateToProps, {
  get_category_menu_setup,
  create_or_check_user_order,
  get_takeAway_time,
})(withRouter(RePaymentCustomerEditModel));
